import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { RichTextEditor } from '@/components/rich-text';

interface CourseAssignmentGradeDialogProps {
  open: boolean;
  isGroupAssignment: boolean;
  fullMarks: number;
  gradeScoreDraft: string;
  gradeFeedbackDraft: string;
  isSaving: boolean;
  onOpenChange: (open: boolean) => void;
  onGradeScoreDraftChange: (value: string) => void;
  onGradeFeedbackDraftChange: (value: string) => void;
  onProvideGetSerializedState: (getter: () => string) => void;
  onCancel: () => void;
  onSave: () => void;
}

const CourseAssignmentGradeDialog = ({
  open,
  isGroupAssignment,
  fullMarks,
  gradeScoreDraft,
  gradeFeedbackDraft,
  isSaving,
  onOpenChange,
  onGradeScoreDraftChange,
  onGradeFeedbackDraftChange,
  onProvideGetSerializedState,
  onCancel,
  onSave,
}: CourseAssignmentGradeDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] overflow-hidden sm:max-w-[760px]">
        <DialogHeader>
          <DialogTitle>Grade assignment</DialogTitle>
        </DialogHeader>
        <div className="max-h-[calc(92vh-92px)] overflow-y-auto space-y-3 pr-1">
          {isGroupAssignment ? (
            <div className="space-y-1">
              <label className="text-sm font-medium">Score</label>
              <Input
                type="number"
                min={0}
                max={fullMarks}
                step="0.01"
                value={gradeScoreDraft}
                onChange={(event) => onGradeScoreDraftChange(event.target.value)}
                placeholder={`0 - ${fullMarks}`}
              />
            </div>
          ) : null}
          <label className="text-sm font-medium">Feedback</label>
          <RichTextEditor
            value={gradeFeedbackDraft}
            onChange={onGradeFeedbackDraftChange}
            placeholder="Write feedback..."
            minHeight={180}
            onProvideGetSerializedState={onProvideGetSerializedState}
          />
          <div className="flex items-center justify-end gap-2">
            <Button type="button" variant="outline" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="button" onClick={onSave} disabled={isSaving}>
              Save
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CourseAssignmentGradeDialog;
